import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/site/Logo";
import Seo from "@/components/site/Seo";

export default function AdminLogin() {
  const { login, user, checked } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (checked && user) navigate("/admin/dashboard"); }, [checked, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-av-black grain flex items-center justify-center px-5">
      <Seo title="Area riservata" path="/admin" />
      <div className="relative z-10 w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo className="h-12" to={null} /></div>
        <form onSubmit={submit} data-testid="admin-login-form" className="rounded-3xl border border-white/10 bg-av-green-dark/30 p-8 sm:p-10" style={{ backgroundColor: "rgba(22,56,29,0.3)" }}>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-10 rounded-full bg-av-bright/15 text-av-lime flex items-center justify-center"><Lock size={18} /></span>
            <h1 className="font-display text-2xl text-av-white">Area di gestione</h1>
          </div>
          <label className="block text-sm text-av-white/80 mb-1.5">Email</label>
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                 className="w-full bg-transparent border-b border-white/25 focus:border-av-lime outline-none py-2.5 text-av-white mb-5" />
          <label className="block text-sm text-av-white/80 mb-1.5">Password</label>
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                 className="w-full bg-transparent border-b border-white/25 focus:border-av-lime outline-none py-2.5 text-av-white mb-6" />
          {error && <p data-testid="admin-login-error" className="text-sm text-red-400 mb-4">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
                  className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-av-bright text-av-black px-6 py-3.5 text-sm font-semibold hover:bg-av-lime transition-colors disabled:opacity-60">
            {loading ? <><Loader2 size={16} className="animate-spin" /> Accesso…</> : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
